var map = {
	"./shape-diamond-aquamarine-gradient.png": 70901,
	"./shape-diamond-aquamarine-light.png": 87438,
	"./shape-diamond-aquamarine.png": 98805,
	"./shape-diamond-blue-gradient.png": 67456,
	"./shape-diamond-blue-light.png": 96644,
	"./shape-diamond-blue.png": 56624,
	"./shape-diamond-cyan-gradient.png": 91308,
	"./shape-diamond-cyan-light.png": 11351,
	"./shape-diamond-cyan.png": 40442,
	"./shape-diamond-green-gradient.png": 89642,
	"./shape-diamond-green-light.png": 89188,
	"./shape-diamond-green.png": 28381,
	"./shape-diamond-grey100.png": 44116,
	"./shape-diamond-grey1000.png": 30706,
	"./shape-diamond-grey200.png": 67298,
	"./shape-diamond-grey25.png": 74019,
	"./shape-diamond-grey300.png": 8942,
	"./shape-diamond-grey400.png": 16086,
	"./shape-diamond-grey50.png": 83809,
	"./shape-diamond-grey500.png": 32587,
	"./shape-diamond-grey600.png": 22303,
	"./shape-diamond-grey700.png": 37672,
	"./shape-diamond-grey800.png": 90791,
	"./shape-diamond-grey900.png": 73500,
	"./shape-diamond-indigo-gradient.png": 2383,
	"./shape-diamond-indigo-light.png": 50557,
	"./shape-diamond-indigo.png": 41553,
	"./shape-diamond-lime-gradient.png": 23657,
	"./shape-diamond-lime-light.png": 71288,
	"./shape-diamond-lime.png": 89813,
	"./shape-diamond-magenta-gradient.png": 62304,
	"./shape-diamond-magenta-light.png": 91847,
	"./shape-diamond-magenta.png": 82966,
	"./shape-diamond-navy-gradient.png": 79565,
	"./shape-diamond-navy-light.png": 59132,
	"./shape-diamond-navy.png": 28063,
	"./shape-diamond-orange-gradient.png": 21941,
	"./shape-diamond-orange-light.png": 83456,
	"./shape-diamond-orange.png": 12466,
	"./shape-diamond-purple-gradient.png": 59537,
	"./shape-diamond-purple-light.png": 35851,
	"./shape-diamond-purple.png": 19012,
	"./shape-diamond-red-gradient.png": 54034,
	"./shape-diamond-red-light.png": 41217,
	"./shape-diamond-red.png": 91449,
	"./shape-diamond-yellow-gradient.png": 36661,
	"./shape-diamond-yellow-light.png": 72490,
	"./shape-diamond-yellow.png": 54947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13577;